<script setup lang="ts">
import { computed } from '#imports'
import type { UIIconUnion } from '@core/types'

export interface SaferGamblingArchivePanelProps {
    icon?: string
    title: string
    qas: Array<{
        id: string
        title: string
        video_id?: string
        body: any
        stem?: string
        ctas?: Array<{
            label: string
            url: string
            variant?: 'primary' | 'secondary'
        }>
        expandableTextBlocks?: Array<{
            title: string
            content: any
        }>
    }>
}

const props = withDefaults(defineProps<SaferGamblingArchivePanelProps>(), {
    icon: ''
})

const isDisabled = computed(() => !props.qas?.length)
</script>

<template>
    <UIExpandable
        :key="`archive-${props.qas?.length ?? 0}`"
        class="archive-panel"
        :disabled="isDisabled"
    >
        <template #header>
            <div class="archive-panel__header">
                <UIIcon
                    v-if="props.icon"
                    class="archive-panel__header-icon"
                    :name="props.icon as UIIconUnion"
                    size="25px"
                />

                {{ title }}
            </div>
        </template>

        <div class="archive-panel__content">
            <div class="archive-panel__content-qa-panels">
                <SaferGamblingQaPanel
                    v-for="qa in props.qas"
                    :key="qa.id"
                    :title="qa.title"
                    :video-id="qa.video_id"
                    :body="qa.body"
                    :ctas="qa.ctas"
                    :expandable-text-blocks="qa.expandableTextBlocks"
                />
            </div>
        </div>
    </UIExpandable>
</template>

<style lang="scss" scoped>
.archive-panel {
    &.expandable--open {
        .archive-panel {
            &__header {
                outline: 1px solid $brand-primary;
            }
        }
    }

    &__header {
        background-color: $faq-bg-color;
        display: flex;
        font-size: 18px;
        padding: 15px;
        border-radius: 8px;
        font-weight: $text-bold;
        color: $link-color;
        margin-bottom: 10px;

        &-icon {
            margin-right: 14px;
        }
    }

    &.expandable--disabled {
        .archive-panel__header {
            background-color: $form-field-disabled;
            cursor: not-allowed;
        }
    }

    &__content {
        &-qa-panels {
            display: flex;
            flex-direction: column;
            gap: 10px;
        }

        :deep(.btn) {
            height: 50px;
            align-items: center;
            margin-top: 15px;
        }
    }
}
</style>
